import { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-primary shadow-md">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 text-white no-underline">
          <span className="text-5xl" style={{ fontFamily: 'Bhorgcust' }}>
            Restauracja Magiczna
          </span>
          <img src="/images/logo.png" alt="Logo" className="h-[3em]" />
        </Link>

        {/* Menu desktop */}
        <ul className="hidden md:flex gap-6 font-body text-sm text-white ml-auto items-center">
          <li><a href="#oferta" className="hover:text-accent">Oferta</a></li>
          <li>
            <Link to="/menu" className="hover:text-accent">Menu</Link>
          </li>
          <li><a href="#catering" className="hover:text-accent">Catering</a></li>
          <li><a href="#opinie" className="hover:text-accent">Opinie</a></li>
          <li><a href="#kontakt" className="hover:text-accent">Kontakt</a></li>
        </ul>

        {/* CTA desktop */}
        <div className="hidden md:block ml-6">
          <a
            href="tel:+48668291465"
            className="flex items-center gap-2 bg-light2 text-primary text-base px-4 py-2 rounded-md font-semibold hover:bg-brandGreenDark transition"
          >
            <Phone className="w-5 h-5" />
            668 291 465
          </a>
        </div>

        {/* Mobile menu toggle button */}
        <button
          className="md:hidden text-white"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </nav>

      {/* Mobile menu */}
      {isOpen && (
        <div className="md:hidden bg-white px-4 pb-4">
          <ul className="flex flex-col gap-3 font-body text-primary">
            <li><a href="#oferta" className="hover:text-accent">Oferta</a></li>
            <li><Link to="/menu" className="hover:text-accent">Menu</Link></li>
            <li><a href="#catering" className="hover:text-accent">Catering</a></li>
            <li><a href="#opinie" className="hover:text-accent">Opinie</a></li>
            <li><a href="#kontakt" className="hover:text-accent">Kontakt</a></li>
            <li>
              <a
                href="tel:+48668291465"
                className="flex items-center gap-2 bg-primary text-white text-base px-4 py-2 rounded-md font-semibold hover:bg-brandGreenDark transition justify-center"
              >
                <Phone className="w-5 h-5" />
                668 291 465
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
